import { sizes } from '@sharefiledev/antd-config';
import { Button, Flex, Typography } from 'antd';
import { BrokenPage } from '../../icons/BrokenPage';
import { t } from '../../utils';

export interface LinkErrorPageProps {
	isBackToSignInButtonEnabled?: boolean;
}

export const LinkErrorPage = ({
	isBackToSignInButtonEnabled = true,
}: LinkErrorPageProps) => {
	const handleBackClick = () => {
		window.location.replace('/');
	};

	return (
		<Flex
			style={{
				flexDirection: 'column',
				alignItems: 'center',
				paddingTop: sizes.MS,
				gap: sizes.MD,
			}}
		>
			<BrokenPage />
			<Flex style={{ gap: sizes.XS, flexDirection: 'column', alignItems: 'center' }}>
				<Typography.Title level={4}>{t('linkAccessErrorPage.title')}</Typography.Title>
				<Typography>{t('linkAccessErrorPage.text')}</Typography>
			</Flex>

			{isBackToSignInButtonEnabled && (
				<Flex style={{ gap: sizes.XS, flexDirection: 'row', alignItems: 'center' }}>
					<Button type="primary" onClick={handleBackClick} size="middle">
						{t('linkAccessErrorPage.button')}
					</Button>
				</Flex>
			)}
		</Flex>
	);
};
